import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDownloadRekapPengurusPusat,
  getDownloadRekapPengurusProvinsi,
  getDownloadRekapPengurusKabkot,
  getDownloadPengurusPusat,
} from "../../../config/Redux/Download/actions";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close"; // Fixed Import

export default function BasicTable(param) {
  const dispatch = useDispatch();

  const dataDetail = useSelector((state) => state.download);
  // console.log(dataDetail)

  let ketum = "";
  let sekjen = "";
  dataDetail?.downloadPengurusPusat?.data?.map((a) => {
    if (a?.data_diri?.id_jabatan === 7) {
      ketum = a?.data_diri?.nama;
    }
    if (a?.data_diri?.id_jabatan === 9) {
      sekjen = a?.data_diri?.nama;
    }
    return a;
  });
  useEffect(() => {
    dispatch(getDownloadRekapPengurusPusat());
    dispatch(getDownloadRekapPengurusProvinsi());
    dispatch(getDownloadRekapPengurusKabkot());
    dispatch(getDownloadPengurusPusat());
  }, [dispatch]);

  const persentase = (penyebut, pembagi) => {
    let persen = 0;
    if (pembagi !== 0) {
      persen = ((penyebut / pembagi) * 100).toFixed(0);
    }
    return persen;
  };

  const convertDate = (time) => {
    let date = new Date(time);
    let month = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];
    return `${(date.getDate() < 10 ? "0" : "") + date.getDate()} ${
      month[date.getMonth()]
    } ${date.getFullYear()}`;
  };

  const exportToWord = async (element, filename) => {
    let css =
      "<style>@page download-paper{size: 8.27in 11.69in;mso-page-orientation: portrait;margin:0.75in 0.50in 0.75in 0.50in;}div.download-paper {page: download-paper;}</style>";
    var preHtml =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>" +
      css +
      "</head><body>";
    var postHtml = "</body></html>";
    var html = preHtml + document.getElementById(element).innerHTML + postHtml;

    var blob = new Blob(["\ufeff", html], {
      type: "application/msword",
    });

    // Specify link url
    var url =
      "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

    // Specify file name
    filename = filename ? filename + ".doc" : "document.doc";

    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = url;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  };

  let temp = 0;
  let tempidx = 0;
  let tempHtml = null;

  return (
    <>
      <div className="download-page">
        {/* Premium Header - Dark Blue Gradient */}
        <div
          id="premium-download-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 32px",
            background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            position: "sticky",
            top: 0,
            zIndex: 100,
          }}
        >
          {/* Left - Title */}
          <div>
            <h2
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#ffffff",
                margin: 0,
                letterSpacing: "0.5px",
              }}
            >
              Rekapitulasi Keterwakilan Perempuan
            </h2>
            <p
              style={{
                fontSize: 13,
                color: "rgba(255, 255, 255, 0.7)",
                margin: "6px 0 0",
                fontWeight: 400,
              }}
            >
              Partai Buruh
            </p>
          </div>

          {/* Right - Action Buttons */}
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={() =>
                exportToWord(
                  "download-paper",
                  "Rekapitulasi Keterwakilan Perempuan",
                )
              }
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                padding: "10px 20px",
                backgroundColor: "#4caf50",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                transition: "all 0.2s ease",
                color: "#ffffff",
                fontSize: 14,
                fontWeight: 600,
                boxShadow: "0 2px 8px rgba(76, 175, 80, 0.3)",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#43a047";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#4caf50";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <DownloadIcon style={{ fontSize: 20 }} />
              Download
            </button>

            <button
              onClick={() => param.setOpenDownload(false)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 44,
                height: 44,
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: 12,
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.4)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.1)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
              }}
            >
              <CloseIcon style={{ fontSize: 22, color: "#ffffff" }} />
            </button>
          </div>
        </div>
        <div id="download-paper">
          <div className="download-paper">
            <div style={{ textAlign: "center" }}>
              REKAPITULASI KETERWAKILAN PEREMPUAN <br />
            </div>
            <br />
            <br />
            <div style={{ textAlign: "left" }}>
              A. KEPENGURUSAN PARTAI POLITIK TINGKAT PUSAT <br />
            </div>
            <br />
            <div className="download-table">
              <table
                border="1"
                frame="border"
                cellSpacing="0"
                cellPadding="0"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid black",
                }}
              >
                <thead>
                  <tr style={{ textAlign: "center" }}>
                    <td style={{ padding: "4px" }}>NO.</td>
                    <td style={{ padding: "4px" }}>PENGURUS</td>
                    <td style={{ padding: "4px" }}>JUMLAH SELURUH PENGURUS</td>
                    <td style={{ padding: "4px" }}>
                      JUMLAH PENGURUS PEREMPUAN
                    </td>
                    <td style={{ padding: "4px" }}>PERSENTASE</td>
                  </tr>
                </thead>
                <tbody>
                  {dataDetail?.downloadRekapPengurusPusat?.data?.map(
                    (list, idx, arr) => {
                      return (
                        <tr key={idx}>
                          <td style={{ padding: "4px", textAlign: "center" }}>
                            1
                          </td>
                          <td style={{ padding: "4px" }}>
                            Dewan Pimpinan Pusat
                          </td>
                          <td style={{ padding: "4px", textAlign: "center" }}>
                            {list?.jumlah_pengurus}
                          </td>
                          <td style={{ padding: "4px", textAlign: "center" }}>
                            {list?.jumlah_pengurus_perempuan}
                          </td>
                          <td style={{ padding: "4px", textAlign: "center" }}>
                            {persentase(
                              parseInt(list?.jumlah_pengurus_perempuan),
                              list?.jumlah_pengurus,
                            )}
                            %
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </table>
            </div>
            <br />
            <div style={{ textAlign: "left" }}>
              B. KEPENGURUSAN PARTAI POLITIK TINGKAT PROVINSI <br />
            </div>
            <br />
            <div className="download-table">
              <table
                border="1"
                frame="border"
                cellSpacing="0"
                cellPadding="0"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid black",
                }}
              >
                <thead>
                  <tr style={{ textAlign: "center" }}>
                    <td style={{ padding: "4px" }}>NO.</td>
                    <td style={{ padding: "4px" }}>PENGURUS</td>
                    <td style={{ padding: "4px" }}>JUMLAH SELURUH PENGURUS</td>
                    <td style={{ padding: "4px" }}>
                      JUMLAH PENGURUS PEREMPUAN
                    </td>
                    <td style={{ padding: "4px" }}>PERSENTASE</td>
                  </tr>
                </thead>
                <tbody>
                  {dataDetail?.downloadRekapPengurusProvinsi?.data?.map(
                    (list, idx, arr) => {
                      return (
                        <tr key={idx}>
                          <td style={{ padding: "4px" }}>{idx + 1}</td>
                          <td style={{ padding: "4px" }}>
                            Provinsi {list?.nama_provinsi}
                          </td>
                          <td style={{ padding: "4px", textAlign: "center" }}>
                            {list?.jumlah_pengurus}
                          </td>
                          <td style={{ padding: "4px", textAlign: "center" }}>
                            {list?.jumlah_pengurus_perempuan}
                          </td>
                          <td style={{ padding: "4px", textAlign: "center" }}>
                            {persentase(
                              parseInt(list?.jumlah_pengurus_perempuan),
                              list?.jumlah_pengurus,
                            )}
                            %
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </table>
            </div>
            <br />
            <div style={{ textAlign: "left" }}>
              C. KEPENGURUSAN PARTAI POLITIK TINGKAT KABUPATEN/KOTA <br />
            </div>
            {dataDetail?.downloadRekapPengurusKabkot?.data?.map(
              (list, idx, arr) => {
                const prevValue = arr[idx - 1];
                let arrData = [];
                let flag = false;
                if (prevValue?.nama_provinsi !== list?.nama_provinsi) {
                  tempHtml = null;
                  flag = true;
                  temp++;
                  tempidx = idx;
                  arrData = arr.filter(function (el) {
                    return el?.nama_provinsi === list?.nama_provinsi;
                  });
                  tempHtml = arrData?.map((list2, index) => {
                    return (
                      <tr key={index}>
                        <td style={{ padding: "4px" }}>{index + 1}</td>
                        <td style={{ padding: "4px" }}>
                          Provinsi {list2?.nama_kab_kot}
                        </td>
                        <td style={{ padding: "4px", textAlign: "center" }}>
                          {list2?.jumlah_pengurus}
                        </td>
                        <td style={{ padding: "4px", textAlign: "center" }}>
                          {list2?.jumlah_pengurus_perempuan}
                        </td>
                        <td style={{ padding: "4px", textAlign: "center" }}>
                          {persentase(
                            parseInt(list2?.jumlah_pengurus_perempuan),
                            list2?.jumlah_pengurus,
                          )}
                          %
                        </td>
                      </tr>
                    );
                  });
                }
                return (
                  <div key={idx}>
                    {flag ? (
                      <div style={{ textAlign: "left" }}>
                        <br />
                        PROVINSI : {list?.nama_provinsi}
                      </div>
                    ) : null}
                    {flag ? (
                      <div className="download-table">
                        <table
                          border="1"
                          frame="border"
                          cellSpacing="0"
                          cellPadding="0"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            border: "1px solid black",
                          }}
                        >
                          <thead>
                            <tr style={{ textAlign: "center" }}>
                              <td style={{ padding: "4px" }}>NO.</td>
                              <td style={{ padding: "4px" }}>PENGURUS</td>
                              <td style={{ padding: "4px" }}>
                                JUMLAH SELURUH PENGURUS
                              </td>
                              <td style={{ padding: "4px" }}>
                                JUMLAH PENGURUS PEREMPUAN
                              </td>
                              <td style={{ padding: "4px" }}>PERSENTASE</td>
                            </tr>
                          </thead>
                          <tbody>{tempHtml}</tbody>
                        </table>
                      </div>
                    ) : null}
                  </div>
                );
              },
            )}
            <br />
            <div style={{ textAlign: "right" }}>
              Jakarta, {convertDate(new Date())}
            </div>
            <br />
            <div style={{ textAlign: "center" }}>
              PIMPINAN PARTAI POLITIK TINGKAT PUSAT
              <br />
              PARTAI BURUH
            </div>
            <br />
            <br />
            <div style={{ textAlign: "center" }}>
              <table style={{ width: "100%", textAlign: "center" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", textAlign: "center" }}>
                      Presiden
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      {ketum}
                    </td>
                    <td style={{ width: "50%", textAlign: "center" }}>
                      Sekretaris Jenderal
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      {sekjen}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
